import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchCatalogSearchData } from "../../store/CoursesCatalog-actions";

import { Controller, useForm } from "react-hook-form";

import TextField from "@material-ui/core/TextField";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Styles from "./FormCatalogFilter.module.css";


const FormCompletedFilter = (props) => {
	const dispatch = useDispatch();
	const { handleSubmit, setValue, control } = useForm();

	const apiConfigData = useSelector((state) => state.apiConfigData);
	const CoursesCatalogSearchData = useSelector((state) => state.CoursesCatalogData.searchData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const url_data =
		apiConfigData.endpoint.domain + apiConfigData.endpoint.coursesCatalogSearch;

	const resetForm = () => {
		console.log("resetForm");
		setValue("Name", "");
		setValue("JobId", "");
		setValue("CatalogId", "");
		setValue("RegionId", "");
		setValue("SubSiteId", "");
		setValue("ModalityId", "");
		setValue("ProgramTypeId", "");
		setValue("Duration", "");
	};

	const onSubmit = (data) => {
		console.log(data);
		props.filterData(data);
	};

	useEffect(() => {
		dispatch(fetchCatalogSearchData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		console.log("CoursesCatalogSearchData", CoursesCatalogSearchData);
	}, [CoursesCatalogSearchData]);

	return (
		<form
			className={Styles["formCompletedFilter"]}
			onSubmit={handleSubmit(onSubmit)}
		>
			<div className={"col-xs-3"}>
				<InputLabel className={Styles["text-field-label"]}>
					Nome
				</InputLabel>
				<Controller
					name="Name"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-name"
							variant="outlined"
							autoComplete="off"
							type="text"
						/>
					)}
				/>
			</div>
			<div className={"col-xs-2"}>
				<InputLabel className={Styles["text-field-label"]}>
					Carteira Profissional
				</InputLabel>
				<Controller
					name="JobId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-JobId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesCatalogSearchData.jobs.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.name}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-2"}>
				<InputLabel className={Styles["text-field-label"]}>
					Família
				</InputLabel>
				<Controller
					name="CatalogId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-CatalogId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesCatalogSearchData.catalogNodes.map((row) => (
								<MenuItem
									key={row.id_Catalogo}
									value={row.id_Catalogo}
									className={Styles["options"]}
								>
									{row.nome}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-2"}>
				<InputLabel className={Styles["text-field-label"]}>
					Provincia
				</InputLabel>
				<Controller
					name="RegionId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-RegionId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesCatalogSearchData.regions.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.name}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-2"}>
				<InputLabel className={Styles["text-field-label"]}>
					Centro de Formação
				</InputLabel>
				<Controller
					name="SubSiteId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-SubSiteId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesCatalogSearchData.subSites.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.name}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-2"}>
				<InputLabel className={Styles["text-field-label"]}>
					Metodologia
				</InputLabel>
				<Controller
					name="ModalityId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-ModalityId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesCatalogSearchData.modalities.map((row) => (
								<MenuItem
									key={row.id}
									value={row.id}
									className={Styles["options"]}
								>
									{row.name}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-2"}>
				<InputLabel className={Styles["text-field-label"]}>
					Programa Específico
				</InputLabel>
				<Controller
					name="ProgramTypeId"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-ProgramTypeId"
							variant="outlined"
							select
							autoComplete="off"
							type="date"
						>
							{CoursesCatalogSearchData.programTypes.map((row) => (
								<MenuItem
									key={row.id_Tipo}
									value={row.id_Tipo}
									className={Styles["options"]}
								>
									{row.nome}
								</MenuItem>
							))}
						</TextField>
					)}
				/>
			</div>
			<div className={"col-xs-2"}>
				<InputLabel className={Styles["text-field-label"]}>
					Duração
				</InputLabel>
				<Controller
					name="Duration"
					control={control}
					defaultValue=""
					rules={{ required: { value: false } }}
					render={({ field: { onChange, name, value } }) => (
						<TextField
							name={name}
							value={value}
							onChange={onChange}
							className={Styles["text-field"]}
							id="filter-name"
							variant="outlined"
							autoComplete="off"
							type="number"
						/>
					)}
				/>
			</div>
			{/* <div className={"col-xs-3"}></div> */}
			{/* <div className={"col-xs-3"}></div> */}
			<div className={"col-xs-3"}>
				<Button
					variant="contained"
					className={Styles["btn-filter"]}
					color="primary"
					disableElevation
					onClick={resetForm}
				>
					Limpar Dados
				</Button>
			</div>
			<div className={"col-xs-3"}>
				<Button
					type="submit"
					variant="contained"
					color="primary"
					className={Styles["btn-search"]}
					disableElevation
				>
					Pesquisar
				</Button>
			</div>
		</form>
	);
};

export default FormCompletedFilter;
